import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-assign-registration-number',
  templateUrl: './assign-registration-number.component.html',
  styleUrls: ['./assign-registration-number.component.scss']
})
export class AssignRegistrationNumberComponent implements OnInit {
  gstrVldtMesg: string;
  SessionNo: any;

  constructor( private route: ActivatedRoute, public umsService: UmsService,
    private modalPopupService: ModalpopService, private fb: FormBuilder,
    public router: Router,  private httpClient: HttpClient, private dialog: MatDialog,
    private spinner:NgxSpinnerService) { }

  courseRegistrationForm: FormGroup;
  MenuCode: string;
  title = "Title Header"
  title_one = "Title one Header"
  title_two = "Title two Header"
  title_three = "Title three  Header"
  courseList = [];
  submitButton = true;
  dialogRef: MatDialogRef<any>;
  GenerateRegnNoCreate=true;
  userPermission: any;
  utp: string;
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null)
    {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Generate RegnNo' && element.PCreate == false)
      {
          this.GenerateRegnNoCreate = false;  
      }
      
    });
  }
    window.scroll(0, 0);
    this.courseRegistrationForm = this.fb.group({
      Course: new FormControl ('',Validators.required),
      Scope: new FormControl (''),
      CShId: new FormControl (''),
      
    });
    this.title = "Assigns Registration Number"
    this.title_one = "Assigns Registration Numbers to New Applications"
    this.title_two = "This process can not be reversed"
    this.title_three = "Preferably, Take a Backup"
   
   }

   fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.loadGrid(this.SessionNo);
      }
    );
  }

   loadGrid(SessionNo){
    let payload = {}
    payload['CShSnNo'] = SessionNo
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    // take the api from ajay and test before push
    this.umsService.getcourseRegistrationList(payload).subscribe((res) => {
      if (res.status) {
        this.courseList = res.data
      } else {
        this.courseList = [];
      }
    },(ERROR: HttpErrorResponse) => {
      this.courseList = []
   });
   }


   keypress(){

   }

   ValidateAndProcess(){
    if(this.courseRegistrationForm.get('Course').valid){
              let data = {};
              data['message'] = 'Do You Wish To Process';
              data['title'] = 'Generate Registration Number';
              data['icon'] = 'fa fa-question';
              this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
              this.dialogRef.afterClosed().subscribe(result => {
                if (result === 'yes') {
                  let payload = {};
                  payload['CShId'] = this.courseRegistrationForm.value['CShId'];
                  payload['Scope'] = this.courseRegistrationForm.value['Scope'];
                  payload['LoginId'] = sessionStorage.getItem('userId');
                  payload['Inst'] = parseInt(sessionStorage.getItem('Inst'))
                  this.umsService.submitRegistrationNumberProcess(payload).subscribe((res) => {
                    if (res.status && res.message == 1){
                      this.gstrVldtMesg = "Regno "+ res.message + "Exist"
                    }else{
                      this.gstrVldtMesg = "Last Regno Assigned, " + res.message
                      let data = {};
                    data['message'] = this.gstrVldtMesg;
                    data['title'] = 'Information';
                    data['icon'] = 'fas fa-close';
                    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                    }
                  },(ERROR: HttpErrorResponse) => {
                    this.gstrVldtMesg = 'API Error'
                    let data = {};
                    data['message'] = this.gstrVldtMesg;
                    data['title'] = 'Information';
                    data['icon'] = 'fas fa-close';
                    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                 });
                }
                else {
                  this.gstrVldtMesg = 'Processing Cancelled'
                  let data = {};
                  data['message'] = this.gstrVldtMesg;
                  data['title'] = 'Information';
                  data['icon'] = 'fas fa-close';
                  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                  return false;
              }
              });
    }else{
      this.gstrVldtMesg = "Select Exam";
      let data = {};
      data['message'] = this.gstrVldtMesg;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
   }

   prepopulate(e){
    this.courseRegistrationForm.controls['Course'].setValue(e.CoName);
    this.courseRegistrationForm.controls['Scope'].setValue('')
    this.courseRegistrationForm.controls['CShId'].setValue(e.CShId);
   }
}


 //   this.route.queryParams.subscribe(
  //     params => {
  //       this.MenuCode =  params['MenuCode'];
       
  //       this.loadpage(this.MenuCode);
  //     }
  //   )